import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableBody,
} from "@mui/material";

export const Rates = () => {
  return (
    <div className="page">
      <Typography
        variant="h3"
        gutterBottom
        sx={{ textDecoration: "underline" }}
        align="center"
      >
        2026 Rates
      </Typography>

      <Typography
        gutterBottom
        sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
      >
        All site rates cover 2 adults, 3 children under 18, and 1 vehicle.
      </Typography>
      <Typography
        gutterBottom
        sx={{ backgroundColor: "#a8d5e5", p: 2, mx: "0.7%" }}
      >
        Unserviced sites have a 3-night minimum stay on all weekends from August
        7 - Sept. 7.
      </Typography>

      {/* Table for summer rates */}
      <Typography variant="h3" align="center" sx={{ mt: 4 }}>
        Summer Rates (June 12 to Sept. 6)
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type of Site</TableCell>
              <TableCell align="center">Nightly Rate (before tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                Unserviced (no electricity or water: meant for small camping
                units)
              </TableCell>
              <TableCell align="center">$54.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Regular Serviced (15/30 Amp outlet and water tap: meant for
                small camping units)
              </TableCell>
              <TableCell align="center">$66.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Premium Serviced (15/30 Amp outlet and water tap: meant for
                medium/large camping units)
              </TableCell>
              <TableCell align="center">$77.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Serviced 50 Amp (50 Amp outlet and water tap: meant for large
                camping units)
              </TableCell>
              <TableCell align="center">$80.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Cabin (15 Amp outlet and water tap outside of cabin)
              </TableCell>
              <TableCell align="center">$112.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Reservation Fee</TableCell>
              <TableCell align="center">$8.85</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Table for summer extras */}
      <Typography variant="h5" align="center" sx={{ mt: 4 }}>
        Extras (the rates above cover 2 adults, 3 children, 1 car)
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Extra</TableCell>
              <TableCell align="center">Nightly Rate (before tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Adult</TableCell>
              <TableCell align="center">$10.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Child</TableCell>
              <TableCell align="center">$4.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Car</TableCell>
              <TableCell align="center">$8.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Dock Space</TableCell>
              <TableCell align="center">
                $1.50 / ft / night (book in advance){" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Electric Vehicle Fee (if you will be charging on your site)
              </TableCell>
              <TableCell align="center">
                $25.00 one-time fee (per electric car){" "}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pumpouts */}
      <Typography variant="h3" align="center" sx={{ mt: 7 }}>
        Pumpouts (same price in value and peak season)
      </Typography>
      <Typography variant="h6" sx={{ mt: 4, ml: 7 }}>
        - We have a free dump station and we offer mobile pumpouts for $25 on
        Mondays, Wednesdays and Fridays (must be booked at least a day in
        advance). None of our sites have sewer hookup.
      </Typography>

      {/* Table for value season rates */}
      <Typography variant="h3" align="center" sx={{ mt: 7 }}>
        Value Season (May 1 - June 11 & Sept 7 - Oct 12)
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type of Site</TableCell>
              <TableCell align="center">Nightly Rate (before tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                Unserviced (no electricity or water: meant for small camping
                units)
              </TableCell>
              <TableCell align="center">$44.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Regular Serviced (15/30 Amp outlet and water tap: meant for
                small camping units)
              </TableCell>
              <TableCell align="center">$54.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Premium Serviced (15/30 Amp outlet and water tap: meant for
                medium/large camping units)
              </TableCell>
              <TableCell align="center">$64.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Serviced 50 Amp (50 Amp outlet and water tap: meant for large
                camping units)
              </TableCell>
              <TableCell align="center">$67.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Cabin (15 Amp outlet and water tap outside of cabin)
              </TableCell>
              <TableCell align="center">$91.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Reservation Fee</TableCell>
              <TableCell align="center">$8.85</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Table for value season extras */}
      <Typography variant="h5" align="center" sx={{ mt: 4 }}>
        Value Season Extras (the rates above cover 2 adults, 3 children, 1 car)
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Extra</TableCell>
              <TableCell align="center">Nightly Rate (before tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Adult</TableCell>
              <TableCell align="center">$8.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Child</TableCell>
              <TableCell align="center">$4.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Car</TableCell>
              <TableCell align="center">$8.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Dock Space</TableCell>
              <TableCell align="center">
                $1.50 / ft / night (book in advance){" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Electric Vehicle Fee (if you will be charging on your site)
              </TableCell>
              <TableCell align="center">
                $25.00 one-time fee (per electric car){" "}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Table for value season seasonal sites */}
      <Typography variant="h5" align="center" sx={{ mt: 4 }}>
        Value Season Seasonal Sites
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Season</TableCell>
              <TableCell align="center">Price (before tax)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Spring (May 1 - June 18)</TableCell>
              <TableCell align="center">$1100.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Fall (Sept 7 - Oct 11)</TableCell>
              <TableCell align="center">$1000.00</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Spring & Fall</TableCell>
              <TableCell align="center">$1900.00</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
